import { Component, ViewEncapsulation, OnInit, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { KYMW2400Component } from '../kymw2400/kymw2400.component';
import { NewSectionModel } from '../kymw2400/vo/new-section.model';

/**
 * セクション追加画面を管理するクラス
 *
 * @export KYMW2403Component
 * @class KYMW2403Component
 */
@Component({
  selector: 'app-kymw2403',
  templateUrl: 'kymw2403.component.html',
  styleUrls: ['kymw2403.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW2403Component extends PlessViewHelperSub implements OnInit {

  // ウィンドウを閉じる際の処理
  public closeFunction: Function;

  public sectionName = String('');
  public sectionDivW = Number(1);
  public sectionDivH = Number(1);

  /**
   *Creates an instance of KYMW2403Component.
   * @param {KYMW00Model} kymw00Model
   * @param {ElementRef} elementRef
   * @param {PlessDialogServiceSub} dialogService
   * @memberof KYMW2403Component
   */
  constructor(
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private dialogService: PlessDialogServiceSub,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof PhaseRegistComponent
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW2403';
  }

  /**
   * 画面を閉じる
   *
   * @memberof KYMW2403Component
   */
  public eventCloseHandler(): void {
    this.closeFunction();
  }

  /**
   * 作成ボタン押下時しょり
   *
   * @memberof KYMW2403Component
   */
  public eventCreateHandler(): void {
    if (this.getInputSectionName() === '') {
      // {0}を入力してください。
      this.dialogService.openAlertGetMessage('E0250', ['セクション名']);
    } else {
      const pageTemplateViewHelper: KYMW2400Component = this.parent;
      pageTemplateViewHelper.addSection(this.createNewSectionVO());

      this.eventCloseHandler();
    }
  }

  /**
   * NewSectionVO作成
   *
   * @private
   * @returns {NewSectionModel}
   * @memberof KYMW2403Component
   */
  private createNewSectionVO(): NewSectionModel {
    const vo: NewSectionModel = new NewSectionModel();
    vo.sectionName = this.getInputSectionName();
    vo.divH = this.sectionDivH;
    vo.divW = this.sectionDivW;
    return vo;
  }

  /**
   * セクション名取得
   *
   * @private
   * @returns {string}
   * @memberof KYMW2403Component
   */
  private getInputSectionName(): string {
    return this.sectionName;
  }

}
